import { IconDefinition, IconName } from "@fortawesome/fontawesome-svg-core";

// eslint-disable-next-line no-restricted-syntax -- an SVG path, not text
const n = (value: number) => +value.toFixed(2);

const circle = (cx: number, cy: number, r: number, clockwise = true) => {
  const sweep = clockwise ? 1 : 0;
  return `M${n(cx - r)} ${n(cy)}a${r} ${r} 0 1 ${sweep} ${n(2 * r)} 0a${r} ${r} 0 1 ${sweep} ${n(-2 * r)} 0z`;
};

const ring = (cx: number, cy: number, outer: number, inner: number) =>
  circle(cx, cy, outer) + circle(cx, cy, inner, false);

const rect = (x: number, y: number, w: number, h: number, r: number) =>
  `M${x + r} ${y}h${w - 2 * r}a${r} ${r} 0 0 1 ${r} ${r}v${h - 2 * r}a${r} ${r} 0 0 1 ${-r} ${r}` +
  `h${-(w - 2 * r)}a${r} ${r} 0 0 1 ${-r} ${-r}v${-(h - 2 * r)}a${r} ${r} 0 0 1 ${r} ${-r}z`;

const hole = (x: number, y: number, w: number, h: number) => `M${x} ${y}v${h}h${w}v${-h}z`;

const ray = (cx: number, cy: number, from: number, to: number, degrees: number, halfWidth: number) => {
  const angle = degrees * Math.PI / 180;
  const [dx, dy, nx, ny] = [Math.cos(angle), Math.sin(angle), Math.sin(angle) * halfWidth, -Math.cos(angle) * halfWidth];
  const point = (along: number, side: number) => `${n(cx + along * dx + side * nx)} ${n(cy + along * dy + side * ny)}`;
  const cap = `A${halfWidth} ${halfWidth} 0 0 1`;
  return `M${point(from, 1)}L${point(to, 1)}${cap} ${point(to, -1)}L${point(from, -1)}${cap} ${point(from, 1)}z`;
};

const custom = (iconName: string, width: number, height: number, path: string): IconDefinition =>
  ({ prefix: "fak", iconName: iconName as IconName, icon: [width, height, [], "", path] });

const GRID = [10, 32, 54];

export const faBlastPattern = custom("blast-pattern", 64, 64,
  GRID.flatMap(y => GRID.map(x => ring(x, y, 9.5, 4))).join(""));

export const faBlastFire = custom("blast-fire", 64, 64,
  ring(32, 32, 12.5, 5.5) + [0, 45, 90, 135, 180, 225, 270, 315].map(degrees => ray(32, 32, 19, 28, degrees, 4)).join(""));

export const faDrillRig = custom("drill-rig", 52, 64,
  rect(9, 1, 10, 36, 2) + [5, 13, 21, 29].map(y => hole(11.5, y, 5, 5)).join("") +
  rect(30, 23, 15, 14, 2) + hole(33, 26, 9, 6) +
  rect(4, 36, 44, 13, 2) +
  rect(1, 50, 50, 13, 6.5) + circle(8, 56.5, 2.5, false) + circle(44, 56.5, 2.5, false));
